import { render, staticRenderFns } from "./ManagerCampEditorDocs.vue?vue&type=template&id=81a7d390&lang=pug&"
import script from "./ManagerCampEditorDocs.vue?vue&type=script&lang=js&"
export * from "./ManagerCampEditorDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports